import StoreProvider from './StoreProvider';

export const store = StoreProvider.getStore()

export default store;